export default __webpack_public_path__ + "static/media/tahi.c1f8dd85.jpeg";